import React from "react";
import "../css/About.css";

export default function About() {
  return (
    <section className="about">
      <div className="about-bg" />

      <div className="about-wrapper">
        {/* INTRO */}
        <div className="about-intro">
          <span className="about-label">About Inquizene</span>

          <h1 className="about-title">
            Engineering <span>Software Excellence</span>
          </h1>

          <p className="about-lead">
            At Inquizene, we craft modern software solutions that help businesses
            operate clearly, scale responsibly, and evolve with confidence.
          </p>
        </div>

        {/* VALUES GRID */}
        <div className="about-grid">
          <div className="about-column">
            <h3>Our Mission</h3>
            <p>
              Deliver innovative, reliable, and scalable software that simplifies
              complex business processes and unlocks growth opportunities.
            </p>
          </div>

          <div className="about-column">
            <h3>Our Vision</h3>
            <p>
              To be the trusted technology partner, providing high-quality,
              thoughtfully engineered solutions for long-term success.
            </p>
          </div>

          <div className="about-column highlight">
            <h3>Core Values</h3>
            <ul className="about-values">
              <li>Innovation & Creativity</li>
              <li>Integrity & Transparency</li>
              <li>Quality & Performance</li>
              <li>Collaboration & Empathy</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="about-cta-bar">
          <div className="about-cta-text">
            <h4>Have a project in mind?</h4>
            <p>
              Let’s collaborate to bring your ideas to life with precision and
              impact.
            </p>
          </div>

          <div className="about-actions">
            <button className="btn-primary">Get in Touch</button>
            <button className="btn-secondary">Learn More</button>
          </div>
        </div>
      </div>
    </section>
  );
}
